import { render, staticRenderFns } from "./InicidenciaTipo.vue?vue&type=template&id=c7cb040e&"
import script from "./InicidenciaTipo.vue?vue&type=script&lang=js&"
export * from "./InicidenciaTipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports